export default __webpack_public_path__ + "static/media/profile-hover.ea52941d.svg";